module.exports = __webpack_public_path__ + "static/media/icoCrunch.683f4077.png";